import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.map";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.keys";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import classNames from 'classnames';
export var RadioField = function RadioField(_ref) {
  var label = _ref.label,
      input = _ref.input,
      meta = _ref.meta,
      wrapperAttributes = _ref.wrapperAttributes,
      wrapperTag = _ref.wrapperTag,
      suppressErrorMessage = _ref.suppressErrorMessage,
      options = _ref.options;
  var fieldId = "".concat(input.name, "_field");
  var hasError = meta.error && meta.touched && !meta.active;
  var classes = {
    'form__input--error': hasError
  };
  var inputElements = Object.keys(options).map(function (option) {
    return React.createElement(Fragment, {
      key: option
    }, React.createElement("input", _extends({}, input, {
      className: classNames(classes),
      type: "radio",
      id: "".concat(fieldId, "_").concat(option),
      checked: option === input.value,
      value: option
    })), React.createElement("label", {
      htmlFor: "".concat(fieldId, "_").concat(option),
      className: "form__label--no-style"
    }, options[option]));
  });
  return React.createElement(wrapperTag || 'div', wrapperAttributes || {}, label ? React.createElement("label", {
    htmlFor: fieldId
  }, label) : null, React.createElement("div", {
    className: "form__radio"
  }, inputElements), hasError && !suppressErrorMessage ? React.createElement("div", {
    className: "error__text text--sm mt-"
  }, meta.error) : null);
};
RadioField.propTypes = {
  input: PropTypes.object,
  meta: PropTypes.object,
  label: PropTypes.element,
  suppressErrorMessage: PropTypes.bool,
  wrapperAttributes: PropTypes.object,
  wrapperTag: PropTypes.string,
  options: PropTypes.object
};